export var WAC_STAGING_URL = 'https://qa-wac.internal.atlassian.com';
export var WAC_PROD_URL = 'https://www.atlassian.com';
export var OPSGENIE_SIGNUP_PATH = '/software/opsgenie/try';
// Bundle expansion is used by JSW, JSD & Confluence
export var WAC_BUNDLE_SIGNUP_PATH = '/try/cloud/signup';
export var WAC_SIGNUP_PATH = '/software';